import { IVerbaScholaStudentAttemptPayload, IVerbaScholaStudentStep } from '../api/VerbaScholaApi';

export interface StudentStepCardProps {
    step: IVerbaScholaStudentStep;
    nextAttemptNumber: () => number;
    onComplete: () => void;
}

export function studentAttemptPayload(attemptNumber: number, answers: IVerbaScholaStudentAttemptPayload['answers'] = []): IVerbaScholaStudentAttemptPayload {
    const now = new Date().toISOString();
    return { id: 0, attempt_number: attemptNumber, idempotency_key: crypto.randomUUID(), started_at: now, submitted_at: now, completed_at: now, answers };
}
